export default __webpack_public_path__ + "static/media/layout.0a1dae31.svg";